import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-upload-file-sample-format',
  templateUrl: './upload-file-sample-format.component.html',
  styleUrls: ['./upload-file-sample-format.component.css']
})
export class UploadFileSampleFormatComponent implements OnInit {
  @Input() uploadType;
  constructor() { }

  ngOnInit() {
  }

}
